import { render, staticRenderFns } from "./SaveNow.vue?vue&type=template&id=7518ddcc&scoped=true"
import script from "./SaveNow.vue?vue&type=script&lang=js"
export * from "./SaveNow.vue?vue&type=script&lang=js"
import style0 from "./SaveNow.vue?vue&type=style&index=0&id=7518ddcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7518ddcc",
  null
  
)

export default component.exports